angular.module("municipalAuthData.components", []).component("municipalAuthData", {
    templateUrl: "ng/components/munAuthorization/municipalAuthData/municipalAuthData.view.html",
    bindings: {
        richiestePostVendita: "=",
        contratti: "=",
        validatePage: "&"
    },
    controllerAs: "municipalAuthDataCtrl",
    controller: function MunicipalAuthData(
        $arcService,
        $userService,
        $timeout,
        DettaglioImmobiliare,
        Sede,
        DatiCatastali
    ) {
        var self = this;

        self.appContract = {
            numeroContratto: null,
            modulo: null,
            cdBeni: []
        }

        self.$onInit = function () {
            self.supportModel = {
                contractList: [],
                radioImmDestination: false,
                importo: "",
                duration: false,
                dettaglioImmList: [],
                type: "munAuthorization",
                dettaglioList: []
            }

            self.supportModel.autorizzazioneComunale = self.richiestePostVendita.metadata.autorizzazioneComunale;
            self.supportModel.listToUpdate = self.supportModel.autorizzazioneComunale.contratti;
            //TODO in attesa di una soluzione definitiva, passo lo stato come stringa
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeConsegna.stato = "";
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeFatturazione.stato = "";
            // self.richiestePostVendita.metadata.variazioneAnagrafica.sedeLegale.stato = "";

            self.supportModel.listToUpdate.forEach(function (element) {
                if (element.dettaglioImmobiliare.length) {
                    element.selected = true;
                    self.supportModel.dettaglioList = element.dettaglioImmobiliare;
                } else {
                    getDettaglioReddito();
                }
            });

            if (!self.supportModel.autorizzazioneComunale.email) {
                getAppUser();
            }

            descriptionLength();
            checkValidityPage();
            $timeout(function () {
                self.enableTooltip = true;
            }, 500)
        };

        self.handleChange = function (property, value) {
            switch (property) {
                case "nominativo":
                case "email":
                    self.supportModel.autorizzazioneComunale.tecnicoIncaricato[property] = value;
                    break;
                case "descrizioneModifiche":
                case "importoModifiche":
                case "durataLavori":
                case "durataGiorno":
                case "importoIndicato":
                    self.supportModel.autorizzazioneComunale[property] = value;
                    break;
                case "doc":
                    self.supportModel.autorizzazioneComunale.documentazione = value;
                    break;
                case "dettaglio":
                    self.supportModel.listToUpdate.forEach(function (contratto) {
                        value.forEach(function (dettaglio) {
                            //se c'è almeno un dettaglio selezionato, contratto.selected = true 
                            if (dettaglio.numero == contratto.numero &&
                                dettaglio.modulo == contratto.modulo &&
                                dettaglio.selected) {
                                contratto.selected = true;
                                contratto.dettaglioImmobiliare = value;
                            }
                        });
                    });
                    break;
                case "emailContatto":
                    self.supportModel.autorizzazioneComunale.email = value;
                    break;
                default:
                    break;
            }
            checkValidityPage();
        }

        var checkValidityPage = function () {
            var sottoscrizione = self.supportModel.autorizzazioneComunale.tecnicoIncaricato.nominativo &&
                self.supportModel.autorizzazioneComunale.tecnicoIncaricato.email &&
                self.supportModel.autorizzazioneComunale.descrizioneModifiche &&
                self.supportModel.autorizzazioneComunale.durataLavori &&
                self.supportModel.autorizzazioneComunale.email;

            var dettaglioImmo = false;
            self.supportModel.autorizzazioneComunale.contratti.forEach(function (contratto) {
                dettaglioImmo = contratto.dettaglioImmobiliare.some(function (dettaglio) {
                    return dettaglio.selected == true
                });
            });

            if (sottoscrizione && dettaglioImmo) {
                self.validatePage({
                    validity: true
                });
                self.supportModel.autorizzazioneComunale.contratti = self.supportModel.listToUpdate;
                self.richiestePostVendita.metadata.autorizzazioneComunale = self.supportModel.autorizzazioneComunale;
            } else {
                self.validatePage({
                    validity: false
                });
            }
        }

        var descriptionLength = function () {
            var input = self.supportModel.autorizzazioneComunale.descrizioneModifiche && self.supportModel.autorizzazioneComunale.descrizioneModifiche.length;
            if (input > 200 && input <= 350) {
                document.getElementById("descChange").style.height = "90px";
            } else if (input > 350 && input <= 500) {
                document.getElementById("descChange").style.height = "120px";
            } else if (input > 500) {
                document.getElementById("descChange").style.height = "150px";
            }
        }

        var getDettaglioReddito = function () {
            self.isPending = true;
            self.supportModel.listToUpdate.forEach(function (contratto) {
                $arcService.
                    getDettaglioReddito(contratto.numero, contratto.modulo)
                    .then(function (response) {
                        if (response) {
                            response.dettaglioImmobiliare.forEach(function (element) {
                                var dettaglio = DettaglioImmobiliare.build();
                                dettaglio.numero = contratto.numero;
                                dettaglio.modulo = contratto.modulo;
                                dettaglio.indirizzo = Sede.build(element.indirizzo);
                                dettaglio.datiCatastali = DatiCatastali.build(element.datiCatastali);
                                dettaglio.selected = true;
                                contratto.dettaglioImmobiliare.push(dettaglio);
                            });
                            self.supportModel.dettaglioList = contratto.dettaglioImmobiliare;
                            self.isPending = false;
                        }
                    }).catch(function (error) {
                        console.log(error)
                        self.isPending = false;
                    })
            })
            checkValidityPage();
        }

        var getAppUser = function () {
            $userService.
                getAppUser()
                .then(function (response) {
                    self.supportModel.autorizzazioneComunale.email = response.email;
                }).catch(function (error) {
                    console.log(error);
                })
        }
    }
});